import type { InternalAxiosRequestConfig } from 'axios';
import config from '../config';

export const SOURCE_SYSTEM_HEADER = 'sourceSystem';
export const SOURCE_SYSTEM = 'CUSTOMER_PORTAL';

const apiBaseUrls = [
  config.VITE_API_BASE_URL,
  config.VITE_AUTH_API_BASE_URL,
  config.VITE_AUTH_FRAMEWORK_URL,
  config.VITE_ANALYTICS_URL,
  config.VITE_CORE_API_BASE_URL,
  config.VITE_AI_AGENT_API_BASE_URL,
  config.VITE_PUBLIC_TOOLS_API_BASE_URL,
].filter(Boolean).map((url) => url.replace(/\/$/, ''));

export const applySourceSystemHeader = (headers: Record<string, unknown>) => {
  if (!headers[SOURCE_SYSTEM_HEADER]) {
    headers[SOURCE_SYSTEM_HEADER] = SOURCE_SYSTEM;
  }
  return headers;
};

export const applySourceSystemAxiosHeader = (requestConfig: InternalAxiosRequestConfig) => {
  const headers = requestConfig.headers ?? {};
  applySourceSystemHeader(headers as unknown as Record<string, unknown>);
  requestConfig.headers = headers;
  return requestConfig;
};

const shouldAddSourceSystem = (input: RequestInfo | URL): boolean => {
  if (typeof input !== 'string' && !(input instanceof URL)) {
    return shouldAddSourceSystem(input.url);
  }

  const url = String(input);
  if (url.startsWith('/')) {
    return true;
  }
  return apiBaseUrls.some((baseUrl) => url.startsWith(baseUrl));
};

export const installSourceSystemFetchHeader = () => {
  if (typeof window === 'undefined' || window.__SOURCE_SYSTEM_FETCH_INSTALLED__) {
    return;
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    if (!shouldAddSourceSystem(input)) {
      return originalFetch(input, init);
    }

    const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
    if (!headers.has(SOURCE_SYSTEM_HEADER)) {
      headers.set(SOURCE_SYSTEM_HEADER, SOURCE_SYSTEM);
    }

    return originalFetch(input, { ...init, headers });
  };

  window.__SOURCE_SYSTEM_FETCH_INSTALLED__ = true;
};

declare global {
  interface Window {
    __SOURCE_SYSTEM_FETCH_INSTALLED__?: boolean;
  }
}